











































import Vue, { PropType } from 'vue'
import { IStudent } from '@/models/IStudent'
import { Actions } from '@/shared/Actions'

export default Vue.extend({
  props: {
    roomId: {
      type: String as PropType<string>,
      required: true
    },
    editable: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    student: {
      type: Object as PropType<IStudent>,
      default: (): IStudent => ({
        name: '',
        surname: '',
        addedBy: 'me'
      })
    }
  },
  computed: {
    isEditingRequestProcessing(): boolean {
      return this.$store.state.isProcessing[Actions.ADMIN_STUDENT_EDIT][
        this.roomId + this.student._id
      ]
    },
    isAddingRequestProcessing(): boolean {
      return this.$store.state.isProcessing[Actions.ADMIN_STUDENT_ADD][this.roomId + this.student] //It needs to be whole student as id is not defined yet
    },
    formRules() {
      return {
        name: [
          {
            required: true,
            message: 'Rodaj imię!',
            trigger: 'blur'
          }
        ],
        surname: [
          {
            required: true,
            message: 'Podaj nazwisko!',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    handleAdd(): void {
      ;(this.$refs.form as any)?.validate()
      if (this.student?.name !== '' && this.student?.surname !== '') {
        this.$emit('onAdd', { ...this.student })
      }
    },
    handleEdit(): void {
      ;(this.$refs.form as any)?.validate()
      if (this.student?.name !== '' && this.student?.surname !== '') {
        this.$confirm(
          `Jesteś pewnien, że chcesz zmodyfikować uczestnika ${this.student?.name} ${this.student?.surname}?`,
          'Potwierdzenie',
          {
            confirmButtonText: 'Tak',
            cancelButtonText: 'Nie',
            type: 'success'
          }
        ).then(() => {
          this.$emit('onEdit', { ...this.student })
        })
      }
    }
  }
})
